<template>
  <div class="chat-wrap">
    <div class="chat-inner">
      <big-img
        v-if="showImg"
        @clickit="viewImg"
        :imgSrc="imgSrc"
      ></big-img>
      <!-- 头部 -->
      <div class="char-header">
        <div class="header-left">在线咨询</div>
      </div>
      <div class="chat-remind">中控技术服务欢迎您，我们将竭诚为您服务！如紧急需求可直接联系4008876000售后客服热线！</div>
      <!-- 聊天区 -->
      <main class="chat-main">
        <div class="chat-main-wrap">
          <div
            class="chat-cont"
            id="chat-cont-id"
          >
            <!-- 显示聊天记录 -->
            <div
              class="chat-record"
              v-if="dataRecord.length"
            >
              <div class="chat-record-title">---- 上次聊到了这里 ----</div>
              <div
                :class="data.msgtype===1?'chat-record-content':'chat-record-content-img'"
                v-for="(data,index) in dataRecord"
                :key="index"
              >
                <!-- 左侧 -->
                <div v-if="data.me==='2'">
                  <div class="chat-left-photo">
                    <img
                      style="width:40px;height:40px;margin-right:5px"
                      src="~@/assets/img/客服-蓝.png"
                    />
                  </div>
                  <div
                    v-if="!data.mediaid"
                    class="chat-left-text left"
                  >{{data.text}}</div>
                  <img
                    class="chat-left-img"
                    v-if="data.mediaid && data.msgtype==2"
                    @click="getImgUrl"
                    :src="'https://zkyjkfile.supcon.com/'+data.mediaid"
                  >
                  <div
                    v-if="data.mediaid && data.msgtype==10"
                    class="chat-left-download"
                  >
                    <div class="download-left">
                      <div class="download-title">{{data.file}}</div>
                      <!-- <img :src="data.content.slice(-3)==='pdf'?'~@/assets/img/pdf.jpg':data.content.slice(-3)==='xls'?'~@/assets/img/excel.png':'~@/assets/img/word.png'" /> -->
                    </div>
                    <div class="download-right">
                      <div class="download-title">{{data.downloadtitle}}</div>
                      <a
                        :href="'https://zkyjkfile.supcon.com/'+data.mediaid"
                        style="color:#14c146 !important"
                      >下载文件</a>
                    </div>
                  </div>
                </div>
                <!-- 右侧 -->
                <div v-else>
                  <div class="chat-right-photo">
                    <img
                      style="width:40px;height:40px;margin-left:5px;"
                      src="~@/assets/img/person_my.png"
                    />
                  </div>
                  <div
                    v-if="!data.mediaid"
                    class="chat-left-text right"
                  >{{data.text}}</div>
                  <img
                    class="chat-right-img"
                    v-if="data.mediaid && data.msgtype==2"
                    @click="getImgUrl"
                    :src="'https://zkyjkfile.supcon.com/'+data.mediaid"
                  >
                  <div
                    v-if="data.mediaid && data.msgtype==10"
                    class="chat-right-download"
                  >
                    <div class="download-left">
                      <img src="~@/assets/img/excel.png" />
                    </div>
                    <div class="download-right">
                      <div class="download-title">{{data.downloadtitle}}</div>
                      <a
                        :href="'https://zkyjkfile.supcon.com/'+data.mediaid"
                        style="color:#14c146 !important"
                      >下载文件</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chat-record-end">---- 以下是新消息 ----</div>
            </div>
            <!-- 正常对话 -->
            <div
              :class="data.type===1 || data.type==='0' || data.type==='1'?'chat-receiver':'chat-receiver-img'"
              v-for="(data,index) in msg"
              :key="index"
            >
              <!-- 左侧 -->
              <div v-if="data.acceptType==='2'">
                <div class="chat-left-photo">
                  <img
                    style="width:40px;height:40px;margin-right:5px"
                    src="~@/assets/img/客服-蓝.png"
                  />
                </div>
                <div
                  class="chat-left-text left"
                  v-if="!data.mediaId"
                >{{data.content}}</div>
                <!-- 图片 -->
                <img
                  v-if="data.mediaId && data.type=='2'"
                  @click="getImgUrl"
                  class="chat-left-img"
                  :src="'https://zkyjkfile.supcon.com/'+data.mediaId"
                />
                <!-- 文件的下载 -->
                <div
                  v-if="data.mediaId && data.type=='10'"
                  class="chat-left-download"
                >
                  <div class="download-left">
                    <img :src="fileType(data.content)" />
                  </div>
                  <div class="download-right">
                    <div>{{data.content}}</div>
                    <a
                      :href="'https://zkyjkfile.supcon.com/'+data.mediaId"
                      style="color:#14c146 !important"
                    >下载文件</a>
                  </div>
                </div>
              </div>
              <!-- 右侧 -->
              <div v-else>
                <div class="chat-right-photo">
                  <img
                    style="width:40px;height:40px;margin-left:5px;"
                    src="~@/assets/img/person_my.png"
                  />
                </div>
                <div
                  class="chat-left-text right"
                  v-if="!data.mediaId"
                >{{data.content}}</div>
                <img
                  v-if="data.mediaId && data.type==2"
                  @click="getImgUrl"
                  class="chat-right-img"
                  :src="'https://zkyjkfile.supcon.com/'+data.mediaId"
                />
                <div
                  v-if="data.mediaId && data.type==10"
                  class="chat-right-download"
                >
                  <div class="download-left">
                    <img :src="fileType(data.downloadtitle)" />
                  </div>
                  <div class="download-right">
                    <div class="download-title">{{data.downloadtitle}}</div>
                    <a
                      :href="'https://zkyjkfile.supcon.com/'+data.mediaId"
                      style="color:#14c146 !important"
                    >下载文件</a>
                  </div>
                </div>
              </div>
              <!-- <a v-if="data.mediaId && data.type==='10'" href="https://zkyjkfile.supcon.com/H_CikLTh7kq_eQF4ly0kHw">xxxx</a> -->
              <!-- <img :src="'https://zkyjkfile.supcon.com/'+data.mediaId" /> -->
            </div>
          </div>
        </div>
      </main>
      <!-- footer 输入内容区 -->
      <div class="chat-footer">
        <!-- 选择表情区域 -->
        <a
          href="#"
          style=""
        ></a>
        <label
          for="common_chat_opr_fileUpload"
          @click="fileUpload_click('file')"
        >
          <img
            style="width: 18px;height: 18px;"
            src="~@/assets/img/up_picture.png"
          />
        </label>
        <input
          type="file"
          name="uploadFile"
          id="common_chat_opr_fileUpload"
          style="position: absolute;clip: rect(0 0 0 0)"
        />
        <textarea
          class="input-footer"
          v-model="mytext"
          @keyup.enter="handleSend"
        />
        </div>
            <button class="chat-send" @click="handleSend">发送</button>
        </div>
    </div>
</template>
<script>
import Axios from 'axios'
import BigImg from './bigImg'
export default {
  data () {
    return {
      showImg: false,
      imgSrc: '',
      dataForm: {
        phone: '',
        content: ''
      },
      lockReconnect: false,
      mytext: '',
      dialogFormVisible: false,
      linkType: '2',
      acceptTerminal: '1',
      acceptType: '1',
      msgType: 1,
      msgContent: '',
      mediaId: '',
      guid: '',
      areaName: '',
      ip: '',
      phoneUrl: '',
      serverId: '',
      serverName: '',
      customerId: '',
      customerPhone: '',
      sessionId: '',
      mobile: '1394138288',
      path: window.SITE_CONFIG['websocketConsult'] + '/intercs/advisoryWebsocket/',
      // path: 'wss://echo.websocket.org/',
      socket: '',
      clientMsgID: '',
      msg: [],
      // test
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      dataRecord: [],
      tt: null,
      downloadtitle: ''
    }
  },
  components: {
    BigImg
  },
  mounted () {
    // console.log(localStorage.getItem("mobile"))
    this.getMobile()
    // this.createWebSocket()
    // this.init();
    // this.getUserID();
    // 获取聊天记录
    // this.getChat();
    // this.getRandomMobile()
  },
  updated () {
    let ele = document.getElementById('chat-cont-id')
    ele.scrollTop = ele.scrollHeight
  },
  methods: {
    fileType (downloadtitle) {
      let fileNameList = downloadtitle.split('.')
      let fileType = fileNameList[fileNameList.length - 1]
      if (fileType === 'pdf') {
        return require('@/assets/img/pdf.jpg')
      }
      if (fileType === 'xls' || fileType === 'xlsx') {
        return require('@/assets/img/excel.png')
      }
      if (fileType === 'doc' || fileType === 'docx') {
        return require('@/assets/img/word.png')
      }
      return require('@/assets/img/zwtp.png')
    },
    getMobile () {
      if (this.$store.state.user.mobile) {
        // 登录有手机号 用手机号
        this.mobile = this.$store.state.user.mobile
      } else {
        if (localStorage.getItem('randomNumber')) {
          this.mobile = localStorage.getItem('randomNumber')
        } else {
          // 随机生成手机号
          this.mobile = this.getRandomMobile()
          localStorage.setItem('randomNumber', this.mobile)
        }
      }
      this.getChat()
      this.init()
    },
    getRandomMobile () {
      var prefixArray = [
        '130',
        '131',
        '132',
        '133',
        '135',
        '134',
        '136',
        '137',
        '138',
        '170',
        '181',
        '187',
        '189',
        '139',
        '185',
        '151',
        '150',
        '186',
        '188'
      ]
      var i = parseInt(10 * Math.random())
      var prefix = prefixArray[i]
      for (var j = 0; j < 11; j++) {
        prefix = prefix + Math.floor(Math.random() * 10)
      }
      return prefix
    },
    // createWebSocket(){
    //     try {
    //         this.socket = new WebSocket(this.path)
    //         this.init();
    //     } catch (e) {
    //         console.log('catch');
    //         this.reconnect(this.path);
    //     }
    // },
    init () {
      // 实例化socket
      //    this.socket = new WebSocket(this.path)
      this.socket = new WebSocket(this.path + this.mobile)
      // 监听socket连接
      // console.log(this.path + this.mobile)
      this.socket.onopen = this.open
      // 监听socket错误信息
      this.socket.onerror = this.error
      // 监听socket消息
      this.socket.onmessage = this.getMessage
      // 监听socket关闭
      this.socket.onclose = this.close
    },
    open () {
      console.log('连接服务器成功')
    },
    error () {
      console.log('连接错误')
    },
    close () {
      console.log('连接关闭')
      // 重新连接
      // this.reconnect(this.path.replace("undefined", this.mobile))
    },
    // reconnect(url){
    //     var that = this;
    //     if (this.lockReconnect) {
    //         return;
    //     };
    //     console.log(url)
    //     this.lockReconnect = true;
    //     this.tt && clearTimeout(this.tt);
    //     this.tt = setTimeout(function () {
    //         that.createWebSocket(url);
    //         that.lockReconnect = false;
    //     }, 4000);
    // },
    // 接收到服务器消息
    getMessage (res) {
      var Msg = JSON.parse(res.data)
      console.log(Msg, '-getMessage--')
      this.acceptType = '2'
      Msg.msgContent.msgContents.forEach(item => {
        let obj = {}
        obj.content = item.content
        obj.mediaId = item.mediaId
        obj.type = item.type
        obj.acceptType = '2'
        this.msg.push(obj)
      })
      this.sessionId = Msg.msgContent.sessionID
      this.msgType = Msg.msgContent.MsgType
      this.msgContent = Msg.msgContent.msgContents.content
      // commandContent === '1015' 不在线直接转留言
      if (Msg.commandContent === '1015') {
        this.linkType = '1'
      } else {
        this.linkType = '2'
      }
    },
    handleSend () {
      if (
        this.mytext === '' &&
        this.msgType === undefined &&
        this.msgType !== 2 &&
        this.msgType !== 10
      ) {
        return
      }
      if (!this.mytext && !this.msgType) {
        return
      }
      if (this.mytext) {
        // 有值 证明是对话
        this.msgContent = this.mytext
        this.msgType = 1
        this.mediaId = ''
      }
      let params = {
        linkType: this.linkType,
        acceptTerminal: this.acceptTerminal,
        acceptType: this.acceptType,
        msgType: this.msgType,
        msgContent: this.msgContent,
        mediaId: this.mediaId,
        areaName: this.areaName,
        guid: this.guid,
        ip: this.ip,
        phoneUrl: this.$store.state.user.headPhoto || '', // this.phoneUrl,
        serverId: this.serverId,
        serverName: this.serverName,
        customerId: this.customerId,
        customerPhone: '' + this.mobile,
        sessionId: this.sessionId
      }
      console.log(params, 'params')
      this.socket.send(JSON.stringify(params))
      let obj = {}
      if (this.linkType === '1') {
        obj.content = this.mytext ? this.mytext : this.msgContent.split('|')[1]
      } else {
        obj.content = this.mytext ? this.mytext : this.msgContent
      }
      obj.mediaId = this.mediaId
      obj.type = this.msgType
      obj.acceptType = '1'
      obj.downloadtitle = this.downloadtitle
      this.msg.push(obj)
      this.mytext = ''
    },
    // 生成guid 每次会话的唯一id
    // getUserID() {
    //     let time = new Date().getTime();
    //     this.guid = time;
    // },
    // 文件上传
    fileUpload_click: function (fileType) {
      document.getElementById(
        'common_chat_opr_fileUpload'
      ).onchange = this.fileUpload_change
    },
    /**
     * 文件上传_选中文件
     */
    fileUpload_change: function (e) {
      // var fileNameIndex = document.getElementById('common_chat_opr_fileUpload').value.lastIndexOf('\\') + 1;
      // var fileName = document.getElementById('common_chat_opr_fileUpload').value.substr(fileNameIndex);
      // var extend = fileName.substring(fileName.lastIndexOf('.') + 1);
      // 2.文件上传
      var formData = new FormData()
      formData.append(
        'uploadfile',
        document.getElementById('common_chat_opr_fileUpload').files[0]
      )
      Axios({
        url: window.SITE_CONFIG['apiURL'] + '/inter/zk400/uploadFile',
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      }).then(res => {
        console.log(res)
        // console.log(res.data.result.data.datum)
        var messageType = res.data.data.datum.filePath
        var dataType = messageType.split('.')[1]
        // linkType == 1 证明是留言
        if (this.linkType === '1') {
          // 判断是文本、图片还是文件
          if (messageType) {
            // 图片
            if (
              dataType === 'jpg' ||
              dataType === 'png' ||
              dataType === 'jpeg' ||
              dataType === 'gif' ||
              dataType === 'bmp'
            ) {
              this.msgType = 2
              this.msgContent =
                res.data.data.datum.id +
                '|' +
                res.data.data.datum.fileName
              console.log('111')
              this.mediaId = res.data.data.datum.id
            } else {
              // 文件
              this.msgType = 10
              this.msgContent =
                res.data.data.datum.id +
                '|' +
                res.data.data.datum.fileName
              this.mediaId = res.data.data.datum.id
              this.downloadtitle = res.data.data.datum.fileName
            }
          } else {
            // 文本
            this.msgType = 1
            this.msgContent = this.mytext
          }
        } else {
          // 证明是在线咨询对话 直接显示就可以了
          //  上传文件 把iD 付给mediaId msgType
          // 判断是 图片 还是 文件
          if (messageType) {
            // debugger
            if (
              dataType === 'jpg' ||
              dataType === 'png' ||
              dataType === 'jpeg' ||
              dataType === 'gif' ||
              dataType === 'bmp'
            ) {
              this.msgType = 2
              this.msgContent = res.data.data.datum.id
              this.mediaId = res.data.data.datum.id
              // console.log(this.mediaId)
            } else {
              // 文件
              this.msgType = 10
              this.msgContent = res.data.data.datum.id
              this.mediaId = res.data.data.datum.id
              this.downloadtitle = res.data.data.datum.fileName
            }
          }
        }
        this.mediaId = res.data.data.datum.id
        this.handleSend()
      })
    },
    getChat () {
      // console.log('手机号', this.mobile)
      this.$request.get(`${window.SITE_CONFIG['apiURL']}/inter/zk400/getChatRecord?phone=${this.mobile}&pagenum=1&pageCount=20`)
        .then(res => {
          this.dataRecord = res.datum || []
        })
      // Axios.get(
      //   window.SITE_CONFIG['apiURL'] +
      //   `/inter/zk400/getChatRecord?phone=${this.mobile}&pagenum=1&pageCount=20`
      // ).then(res => {
      //   console.log(res, 'getChat')
      //   if (res.data.result.data.datum) {
      //     this.dataRecord = res.data.result.data.datum
      //   } else {
      //     this.dataRecord = []
      //   }
      // })
    },
    viewImg () {
      this.showImg = false
    },
    getImgUrl (e) {
      this.showImg = true
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src
    }
  }
}
</script>
<style scoped>
.chat-wrap {
  width: 100%;
  height: 560px;
}
.chat-inner {
  width: 750px;
  height: 100%;
  margin: 10px auto 0px;
  overflow: hidden;
  box-shadow: 0 1px 5px 2px #ccc;
}
.char-header {
  position: relative;
  height: 55px;
  line-height: 55px;
  background: #82bbec;
  font-size: 16px;
  color: #024182;
  font-weight: 550;
  text-align: center;
}
.char-header .header-left {
  /* float:left; */
  /* margin-left:15px; */
  text-align: center;
}
.char-header .header-right {
  float: right;
  margin-right: 15px;
}
.chat-main {
  height: 300px;
  position: relative;
}
.chat-main-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  font-size: 12px;
  float: left;
  border: 0px;
}
/* 聊天内容区 */
.chat-cont {
  position: relative;
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* 输入内容区 */
.chat-footer {
  position: relative;
  width: 100%;
  border-top: 1px solid #ccc;
}
.input-footer {
  width: 99%;
  padding: 2px;
  height: 80px;
  resize: none;
  overflow: auto;
  line-height: 1.5;
  border: 0;
  outline: none;
}
.chat-send {
  float: right;
  width: 80px;
  height: 38px;
  margin-right: 16px;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}
.chat-emoj {
  height: 20px;
  padding: 10px;
  text-align: left;
}
/* 识别不同人 */
.left {
  background: white;
  animation: toLeft 0.5s ease both 1;
  text-align: left;
  border: 1px solid #ccc;
  animation: toright 0.5s ease both 1;
  /* height:40px; */
  line-height: 40px;
  padding-left: 5px;
  float: left;
  padding-right: 5px;
}
.right {
  color: #000000;
  background-color: #f9fbfc;
  border: 1px solid #ccc;
  animation: toright 0.5s ease both 1;
  /* height:40px; */
  line-height: 40px;
  padding-right: 5px;
  text-align: left;
  float: right;
  padding-left: 5px;
}
/* 显示文字 */
.chat-receiver {
  padding-left: 5px;
  padding-top: 5px;
  margin-bottom: 5px;
  min-height: 50px;
  height: auto;
  padding-right: 5px;
}
/* 显示图片和文件 */
.chat-receiver-img {
  height: 140px;
  padding-left: 5px;
  padding-top: 5px;
  margin-bottom: 5px;
  padding-right: 5px;
}
.chat-left-photo {
  float: left;
}
.chat-left-text {
  border-radius: 5px;
  max-width: 350px;
  height: auto;
}
.chat-record-content::after {
  content: '';
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.chat-receiver::after {
  content: '';
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.chat-left-img {
  width: 120px;
  height: 120px;
}
.chat-right-img {
  width: 120px;
  height: 120px;
  float: right;
}
.chat-left-download {
  width: 230px;
  height: 100px;
  border: 3px solid #14c146;
  padding: 10px;
  float: left;
}
.chat-right-download {
  width: 230px;
  height: 100px;
  border: 3px solid #14c146;
  padding: 10px;
  float: right;
}
.download-left {
  width: 70px;
  height: 70px;
  float: left;
  margin-right: 10px;
}
.download-left img {
  width: 70px;
  height: 70px;
}
.download-right {
  width: 120px;
  height: 100px;
  float: left;
}
.chat-right-photo {
  float: right;
}
.chat-right-text {
  border-radius: 15px;
}
/* 聊天记录 */
.chat-record {
  width: 100%;
  margin-top: 5px;
  height: auto;
}
.chat-record-title {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.chat-record-content {
  /* height:50px; */
  height: auto;
  padding-left: 5px;
  padding-top: 5px;
  margin-bottom: 5px;
  padding-right: 5px;
}
.chat-record-content-img {
  height: 130px;
}
.chat-record-end {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.download-title {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.chat-remind {
  margin-left: 20px;
  margin-top: 5px;
  width: 710px;
  height: 30px;
  background-color: rgb(224, 235, 255);
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;
  color: #333;
}
</style>
